import { qbrickEditorLoaderUrl } from '../../utils/config';

export const QBRICK_EDITOR_TAG = 'qbrick-editor';

const SCRIPT_ELEMENT_ID = 'qbrick-editor-script';
const SCRIPT_URL = qbrickEditorLoaderUrl || 'https://encoder.qbrick.com/editor/qbrick-editor.js';

let loadingPromise: Promise<void> | null = null;

// Loads the encoder bundle that registers the <qbrick-editor> custom element.
// The bundle is fetched once per session and shared by every dialog instance.
export const loadQbrickEditor = (): Promise<void> => {
	if (window.customElements.get(QBRICK_EDITOR_TAG)) {
		return Promise.resolve();
	}

	if (!loadingPromise) {
		loadingPromise = new Promise<void>((resolve, reject) => {
			const script = document.createElement('script');
			script.id = SCRIPT_ELEMENT_ID;
			script.src = SCRIPT_URL;
			script.async = true;
			script.onload = () => resolve();
			script.onerror = () => {
				// Drop the failed tag so a later attempt can load it again
				script.remove();
				loadingPromise = null;
				reject(new Error(`Failed to load ${SCRIPT_URL}`));
			};
			document.body.appendChild(script);
		}).then(() => window.customElements.whenDefined(QBRICK_EDITOR_TAG).then(() => undefined));
	}

	return loadingPromise;
};
